// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/** Ripples */\n/** Elements */\n/* Palette generated by Material Palette - materialpalette.com/blue/amber */\n/** Ripples */\n/** Elements */\n.toggle-icon[data-v-7c689738]:not(.pressed) {\n  opacity: 0.6;\n}\n.pressed[data-v-7c689738] {\n  background-color: rgba(0, 0, 0, 0.11);\n}", ""]);
// Exports
module.exports = exports;
